import {
  PREMIUM_URL,
  PRINTFUL_CONNECTION_URL,
  TARGET_STEP_PARAM,
  WIX_DASHBOARD_URL,
  WIX_EDITOR_URL,
  WIX_LOGIN_URL,
} from 'config/consts';
import { ActionId, StepId } from 'config/steps';
import { useAppStore } from 'stores/appStore';
import { assertString } from 'utils/invariants';
import { urlUtils } from 'utils/url';
import { windowUtils } from 'utils/window';

const _forceStale = () => new Promise((resolve) => setTimeout(resolve, 30 * 1000));

const redirectToLogin = async () => {
  if (!window.__IS_LOGGED_IN__) {
    const redirectUrl = urlUtils.buildUrlWithParams(window.location.href, {
      [TARGET_STEP_PARAM]: ActionId.CreateMetaSite,
    });
    windowUtils.redirectToUrl(WIX_LOGIN_URL, {
      postSignUp: redirectUrl,
      postLogin: redirectUrl,
      forceRender: 'true',
    });
    await _forceStale();
  }
};

const redirectToConnectPrintful = async () => {
  if (!window.__IS_PRINTFUL_CONNECTED__) {
    const { metaSiteId } = useAppStore.getState();
    assertString(metaSiteId);
    const baseParams = windowUtils.getUrlQueryParams();
    const redirectUrl = urlUtils.buildUrlWithParams(window.location.origin + window.__BASEURL__ + metaSiteId, {
      ...baseParams,
      [TARGET_STEP_PARAM]: StepId.SelectImage,
    });
    windowUtils.redirectToUrl(PRINTFUL_CONNECTION_URL, {
      isTosAccepted: '1',
      redirectUrl,
      metaSiteId,
    });
    await _forceStale();
  }
};

const redirectToUpgradePlan = async () => {
  const { metaSiteId } = useAppStore.getState();
  windowUtils.redirectToUrl(PREMIUM_URL, {
    siteGuid: metaSiteId,
    referralAdditionalInfo: 'add-domain-purchase-intent-dropshipping',
    petri_ovr: 'specs.premium.RemoveLightPlanForDropShipping:true',
  });
  await _forceStale();
};

const redirectToDesignSite = async () => {
  const { metaSiteId } = useAppStore.getState();
  const url = [WIX_EDITOR_URL, metaSiteId].join('/');
  windowUtils.redirectToUrl(url);
};

const redirectToManageProducts = async () => {
  const { metaSiteId } = useAppStore.getState();
  const url = [WIX_DASHBOARD_URL, metaSiteId, 'wix-stores', 'products'].join('/');
  windowUtils.redirectToUrl(url);
};

const redirectToMobileApp = async () => {
  const mobileProvider = windowUtils.getMobileProvider();
  if (mobileProvider === 'apple') {
    windowUtils.redirectToUrl('https://apps.apple.com/app/id1545924344');
  } else if (mobileProvider === 'google') {
    windowUtils.redirectToUrl('https://play.google.com/store/apps/details?id=com.wix.admin');
  }
};

export const redirects = {
  redirectToLogin,
  redirectToConnectPrintful,
  redirectToUpgradePlan,
  redirectToDesignSite,
  redirectToManageProducts,
  redirectToMobileApp,
};
